// profileLinks.js
// This module attaches a global click handler on user profile links.
// When a user clicks a profile link with data attributes (e.g., a '#' link with a plus icon),
// it will either follow the user (if not already following) or redirect to their profile.

export function initProfileLinks(config) {
    const { isAuthenticated, currentUserId, currentUserUsername, csrfToken } = config;
  
    document.addEventListener('click', async (event) => {
      const linkEl = event.target.closest('.user-profile-link');
      if (!linkEl) return;
  
      // If the link already has a normal href (and no follow data), let it work normally.
      if (linkEl.href && !linkEl.hasAttribute('data-author-id')) return;
  
      const authorId = linkEl.getAttribute('data-author-id');
      const authorUsername = linkEl.getAttribute('data-author-username');
      const isFollowingAttr = linkEl.getAttribute('data-is-following');
  
      if (authorId && authorUsername && isFollowingAttr !== null) {
        event.preventDefault();
  
        if (!isAuthenticated) {
          $('#authModal').modal('show');
          return;
        }
  
        // If the author is the current user, go to your own profile.
        if (authorId === currentUserId) {
          window.location.href = `/@${currentUserUsername}`;
          return;
        }
  
        const isFollowing = (isFollowingAttr === 'true');
        if (isFollowing) {
          // Already following, simply navigate to their profile.
          window.location.href = `/@${authorUsername}`;
          return;
        } else {
          // Confirm before following.
          const confirmed = confirm(`Follow @${authorUsername}?`);
          if (!confirmed) return;
  
          try {
            const resp = await fetch(`/account/toggle_follow/${authorId}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
              },
            });
            if (!resp.ok) {
              window.showToast('Error following user.', 'danger');
              return;
            }
            const data = await resp.json();
            if (data.success) {
              // Mark the link as now following.
              linkEl.setAttribute('data-is-following', 'true');
              const plusIcon = linkEl.querySelector('.follow-plus-icon');
              if (plusIcon) {
                plusIcon.style.display = 'none';
              }
              // Update any other link with the same author ID.
              const allLinks = document.querySelectorAll(`.user-profile-link[data-author-id="${authorId}"]`);
              allLinks.forEach((itemLink) => {
                itemLink.setAttribute('data-is-following', 'true');
                const otherPlus = itemLink.querySelector('.follow-plus-icon');
                if (otherPlus) {
                  otherPlus.style.display = 'none';
                }
                // Optionally update href to point directly to the profile.
                itemLink.href = `/@${authorUsername}`;
              });
              // Finally, redirect to their profile.
              window.location.href = `/@${authorUsername}`;
            } else {
              window.showToast(data.error || 'Failed to follow user.', 'danger');
            }
          } catch (err) {
            console.error('Error toggling follow from profile link:', err);
            window.showToast('Could not follow user.', 'danger');
          }
        }
      }
    });
  }
  